import styled, { css } from 'styled-components';

import { sidebarConfig } from '@ovpn/ui/sidebar';

import { config } from './sidebarConfig';

export const PusherContent = styled.div<{ $open: boolean; $isMobile: boolean; $isTablet: boolean }>`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 100%;
    height: calc(100% - var(--sidebar-top-offset, 0));
    padding-top: var(--sidebar-top-offset, 0);
    padding-left: ${t =>
        t.$open
            ? `var(--sidebar-left-offset, ${sidebarConfig.desktopWidthExpanded}px)`
            : `${sidebarConfig.desktopWidthCollapsed}px`};

    @media (min-width: ${(config.mobile + config.tablet) / 2}px) {
        transition: ${config.transition};
    }

    will-change: padding-left;

    ${t =>
        t.$isTablet &&
        css`
            padding-left: ${sidebarConfig.desktopWidthCollapsed}px;
    `}

    ${t =>
        t.$isMobile &&
        css`
            padding-top: calc(var(--sidebar-top-offset, 0) + 56px);
            padding-left: 0;
    `}
`;
